import ActivationModal from './ActivationModal';
import ActivationButton from './ActivationModal/ActivationButton';
import LorawanActionsModalMain from './LorawanActionsModalMain';

const LorawanActionsModalNew = {
  ActionsModal: LorawanActionsModalMain,
  ActivationModal,
  ActivationButton,
};

export default LorawanActionsModalNew;
